/**
 * @generated SignedSource<<662005e8736ebad71b83326e0a88c880>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MonthByMonthPersonLoader_viewer$data = {
  readonly company: {
    readonly resourceBasedPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly profilePictureId: string | null;
          readonly aggregatedResourceNumbers: ReadonlyArray<string | null>;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "MonthByMonthPersonLoader_viewer";
};
export type MonthByMonthPersonLoader_viewer$key = {
  readonly " $data"?: MonthByMonthPersonLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MonthByMonthPersonLoader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "pageSize",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "company",
          "resourceBasedPersons"
        ]
      }
    ]
  },
  "name": "MonthByMonthPersonLoader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": "resourceBasedPersons",
          "args": [
            {
              "kind": "Literal",
              "name": "aggregateLevel",
              "value": "MONTH"
            },
            {
              "kind": "Literal",
              "name": "aggregates",
              "value": [
                "forecastBillableUtilization",
                "forecastBillableUtilizationWin",
                "forecastBillableUtilizationSoft",
                "forecastBillableUtilizationSoftWin",
                "forecastBillableUtilizationHard",
                "forecastResourceUtilization",
                "forecastResourceUtilizationWin",
                "forecastResourceUtilizationSoft",
                "forecastResourceUtilizationSoftWin",
                "forecastResourceUtilizationHard",
                "forecastBillableUtilizationTaskAndAllocationsCombined",
                "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                "forecastResourceUtilizationTaskAndAllocationsCombined",
                "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                "forecastResourceUtilizationTaskAndAllocationsCombinedHard"
              ]
            },
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_resourceBasedPersons_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "aggregatedResourceNumbers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "58e05b2faf9f97eef4675e2c0c6a74ee";

export default node;
